<template>
  <div class="footer__info" style="opacity: 0;">
    <div class="footer__info__wrapper apollo__magnetism">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="footer__info__toggle" > <circle r="11" cx="12" cy="12" /> </svg>
      </div>
      <div class="footer__info__hover">P.Iva 11817670018</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Info',
}
</script>

<style lang="scss" scoped>
.footer__info {
  position: absolute;
  left: 0;
  bottom: 0;
  
  padding: 25px;

  display: none;
  
  @include mq(ipadP) {
    padding: rem(40px);
    display: block;
  }

  @include mq(ds) {
    padding: rem(60px);
  }

  &__wrapper {
    height: rem(40px);
    display: flex;
    flex-flow: row wrap;
    align-items: center;

    &:hover {
      .footer__info {
        &__toggle {
          circle {
            stroke-dashoffset: 94px;
          }
        }

        &__hover {
          opacity: 1;
          transform: translate3d(0, 0%, 0);
        }
      }
    }
  }


  &__toggle {
    position: relative;
    width: 12px;
    height: 12px;
    font-size: 0;


    circle {
      fill: none;
      stroke: $color-dark;
      stroke-width: 1px;

      stroke-dasharray: 94px;
      stroke-dashoffset: 0px;
      transition: all 0.5s ease-out;
    }
  }

  &__hover {
    position: relative;
    white-space: nowrap;
    font-size: rem(14px);
    top: rem(2px);
    padding-left: 10px;

    opacity: 0;
    transform: translate3d(0, 50%, 0);

    transition: all 0.3s ease-out;
  }
}
</style>
